import removeAccents from 'remove-accents';
export const noSpaces = (str: string | undefined) => {
  if (!str || !str.length) {
    return '';
  }

  return removeAccents(str)
    .toLowerCase()
    .replace(/[^\w\s]/gi, '')
    .split(' ')
    .join('-')
    .replace(/en-espanol/gi, 'esp');
};

export const generateSlug = (str: string): string =>
  noSpaces(str).toLowerCase();

export const normalizeSearchTerm = (str: string | undefined) => {
  const normalizedTerm = noSpaces(str)
    .replace(/[.,/#!$%^&*;:{}=\-_`'~()]/g, '')
    .replace(/\s/g, '')
    .toLowerCase();
  return normalizedTerm;
};

export const capitalizeAllWords = (str: string) => {
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}